import { Route } from 'react-router-dom'

import RequireAuthentication from '@/router/guards/RequireAuthentication'
import Login from '@/modules/Auth/pages/Login/login'
import TwoFactorAuth from '@/modules/Auth/pages/TwoFactorAuth'
import Choice from '@/modules/Auth/pages/Choice/choice'
import MagicLink from '@/modules/Auth/pages/MagicLink'
import ForgotPassword from '@/modules/Auth/pages/ForgotPassword'
import ChangePassword from '@/modules/Auth/pages/ChangePassword'
import ConfirmPassword from '@/modules/Auth/pages/ConfirmPasswordPage'
import ChangePasswordSuccess from './pages/ChangePasswordSuccess'
import MagicLinkValidation from './pages/MagicLinkValidation'
import TermsRefused from './pages/TermsRefused'

const AuthRoutes = [
  <Route exact path="/login/:clinic" key="/login/:clinic" component={Login} />,
  <Route path="/login" key="/login" component={Login} />,
  <Route exact path="/escolha" key="/escolha" component={Choice} />,
  <Route
    exact
    path="/escolha/:clinic"
    key="/escolha/clinic"
    component={Choice}
  />,
  <RequireAuthentication
    exact
    path="/autenticacao-dois-fatores"
    key="/autenticacao-dois-fatores"
    component={TwoFactorAuth}
  />,
  <RequireAuthentication
    exact
    path="/autenticacao-dois-fatores/:clinic"
    key="/autenticacao-dois-fatores/:clinic"
    component={TwoFactorAuth}
  />,
  <Route
    exact
    path="/redirecionar/:token"
    key="/redirecionar/:token"
    component={MagicLink}
  />,
  <Route
    exact
    path="/redirecionar/:token/:redirectTo"
    key="/redirecionar/:token/:redirectTo"
    component={MagicLink}
  />,
  <Route
    exact
    path="/esqueci-senha"
    key="/esqueci-senha"
    component={ForgotPassword}
  />,
  <Route
    exact
    path="/esqueci-senha/:clinic"
    key="/esqueci-senha/:clinic"
    component={ForgotPassword}
  />,
  <Route
    exact
    path="/atendimento-agendado/validar/atendimento"
    key="/atendimento-agendado/validar/atendimento"
    component={MagicLinkValidation}
  />,
  <Route
    exact
    path="/termos-recusados"
    key="/termos-recusados"
    component={TermsRefused}
  />,
  <RequireAuthentication
    exact
    path="/trocar-senha"
    key="/trocar-senha"
    component={ChangePassword}
  />,
  <RequireAuthentication
    exact
    path="/confirmar-senha"
    key="/confirmar-senha"
    component={ConfirmPassword}
  />,
  <RequireAuthentication
    exact
    path="/trocar-senha/sucesso"
    key="/trocar-senha/sucesso"
    component={ChangePasswordSuccess}
  />,
]

export default AuthRoutes
